<template>
  <div class="accordion">
    <div class="accordion__header-wrapper">
      <button class="accordion__header"
              aria-label="Toggle accordion"
              @click="toggleAccordion">
        <div class="accordion__heading">
          <slot name="header">
            Accordion section
          </slot>
        </div>

        <font-awesome-icon icon="chevron-down"
                           :rotation="rotation">
        </font-awesome-icon>
      </button>
    </div>

    <CollapseTransition :collapsed="!open">
      <div class="accordion__body">
        <slot />
      </div>
    </CollapseTransition>
    <div v-if="!open"
         class="accordion__body printable-body">
      <slot />
    </div>
  </div>
</template>

<script type="text/babel">
import CollapseTransition from "~/Components/Transitions/Collapse.vue";

export default {
  name: "Accordion",
  components: {
    CollapseTransition
  },
  data: () => ( {
    open: false
  } ),
  computed: {
    rotation () {
      let result = null;

      if ( this.open ) {
        result = 180;
      }

      return result;
    }
  },
  methods: {
    toggleAccordion () {
      this.open = !this.open;
    }
  }
};
</script>

<style lang="less" scoped>
.accordion__header {
  background: none;
  border: none;
  display: block;
  width: 100%;
  text-align: left;
}

.accordion__body {
  @media print {
    display: none;
  }
}

.printable-body {
  display: none;

  @media print {
    display: block;
  }
}
</style>
